export const getUrlParameters = (parametersObject) => {
  const parameters = parametersObject ? Object.keys(parametersObject) : [];

  if (parameters.length === 0) {
    return '';
  }

  let result = '?';
  
  parameters.forEach((element) => {
    if (parametersObject[element] || parametersObject[element] === 0) {
      result += `&${element}=${parametersObject[element]}`;
    }
  });

  return result;
};
